import mock from './mock'
import './data/economic-calendar'
import './data/customer-wallet'
import './data/transaction-history'
import './data/deposit'
import './data/withdraw'

mock.onAny().passThrough() // forwards the matched request over network
